"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modelCanRun = modelCanRun;
exports.carbonEmissions = carbonEmissions;
exports.modelCanRunVersion = exports.explanation = exports.modelVersion = exports.modelName = void 0;

var _definitions = require("../../definitions");

var _countries = _interopRequireDefault(require("../countries.json"));

var _utils = require("../utils");

var modelName = 'hotelpercountry';
exports.modelName = modelName;
var modelVersion = '1';
exports.modelVersion = modelVersion;
var explanation = {
  text: 'Calculations take into account the emissions of a stay depending of the country',
  links: [{
    label: 'UK GOV DEFRA (2009)',
    href: 'https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2019'
  }]
};
exports.explanation = explanation;
var modelCanRunVersion = 1;
exports.modelCanRunVersion = modelCanRunVersion;

function modelCanRun(activity) {
  var countryCodeISO2 = activity.countryCodeISO2,
      endDatetime = activity.endDatetime,
      activityType = activity.activityType,
      lineItems = activity.lineItems;

  if (activityType === _definitions.ACTIVITY_TYPE_PURCHASE && lineItems && lineItems.length && lineItems.some(function (l) {
    return l.identifier === _definitions.PURCHASE_CATEGORY_ENTERTAINMENT_HOTEL;
  }) && countryCodeISO2 && endDatetime) {
    if (_countries["default"].countries[activity.countryCodeISO2.toUpperCase()]) {
      return true;
    }
  }

  return false;
}
/*
The carbon intensity is per night stayed for one room
*/


function carbonIntensity(activity) {
  // The data for all the countries can be found here:
  // https://www.gov.uk/government/publications/greenhouse-gas-reporting-conversion-factors-2019
  // Source for the division of the "Caribbean region" in ISO2 country codes: (2020, January 9). Carribean. Retrieved from https://en.wikipedia.org/wiki/Caribbean
  var valuePerRoom = 40.3; // This default value is the median of all the values given in the above document

  if (_countries["default"].countries[activity.countryCodeISO2.toUpperCase()].hotelFootprintKilogramsPerHotelNight) {
    valuePerRoom = _countries["default"].countries[activity.countryCodeISO2.toUpperCase()].hotelFootprintKilogramsPerHotelNight;
  }

  return valuePerRoom / (activity.participants || 1);
}
/*
Carbon emissions of an activity (in kgCO2eq)
*/


function carbonEmissions(activity) {
  var durationHours = (0, _utils.getActivityDurationHours)(activity);
  return carbonIntensity(activity) * Math.ceil(durationHours / 24);
}